





































import { Component, Vue } from "vue-property-decorator";
import store from "../store";

@Component({
  components: {
  }
})
export default class NavBar extends Vue {
  public isActive = true;
  public email = localStorage.getItem("email");

  logout() {
    localStorage.clear();
    store.commit("logoutSuccess");
    this.$router.push("login");
  }

  public loggedIn() {
    const publicRoutes = ["login"];
    return !publicRoutes.includes(this.$route.name as string);
  }
}
